<template>
  <ContainerComponent>
    <div class="main">
      <div class="content">
        <div class="header">
          <div class="title">
            <p>Ericsson Imagine Studio</p>
          </div>
          <Tabs :activate-tab="activateTab" :active-tab="activeTab" />
        </div>
        <div class="container">
          <div class="header">
            <h2>{{ showcaseTitle }}</h2>
            <div class="labels">
              <span class="capacity">Capacity</span>
              <span class="compact">Compact</span>
              <span class="coverage">Coverage</span>
            </div>
          </div>
          <div class="body">
            <div class="image-container">
              <div class="placeholder">
                <i v-show="loadingShowcase" class="icon loading" />
                <InlineSvg v-if="buildNumber"
                  ref="showcase"
                  :src="`${staticUrl}SVGs/${showcaseSvg}` + '?' + buildNumber"
                  @loaded="onLoadedAction"
                />
              </div>
            </div>
          </div>
        </div>
        <div ref="productFamilyFooter" class="bottom-escape">
          <div class="bottom-inner">
            <i
              class="icon icon-arrow-left text-xl clickable"
              @click="goBack($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </ContainerComponent>
</template>

<script>
import ContainerComponent from '@/components/ContainerComponent';
import InlineSvg from 'vue-inline-svg';
import Tabs from '@/components/TabsComponent';
import { getStaticUrl } from '@/helpers';
import readIsManaVersionFlag from '@/shared/manaVersionHelper';
import axios from 'axios';
import StaticUrlService from '@/services/staticUrlService';

export default {
  components: {
    ContainerComponent,
    InlineSvg,
    Tabs
  },
  props: {
    productsId: { type: String, default: 'productViewer' }
  },
  data() {
    return {
      loadingShowcase: true,
      activeTab: 0,
      buildNumber: 0
    };
  },
  computed: {
    showcaseTitle() {
      switch (this.activeTab) {
        case 0:
          return 'Wall display';
        case 1:
          return 'Tower display';
        case 2:
          return 'Cabinet display';
        default:
          return '';
      }
    },
    showcaseSvg() {
      switch (this.activeTab) {
        case 0:
          return 'T21_Studio_Wall.svg';
        case 1:
          return 'T21_Studio_Tower.svg';
        case 2:
          return 'T21_Studio_Cabinet.svg';
        default:
          return '';
      }
    },
    staticUrl () {
      return getStaticUrl(null, this.$route.name);
    }
  },
  async mounted() {
    if (this.$route.query.activeTab) {
      this.activateTab(parseInt(this.$route.query.activeTab));
    }

    const fullStaticUrl = await StaticUrlService.getFullStaticUrl(null, this.$route.name);
    axios.get(`${fullStaticUrl}productData.json?` + Date.now()).then(result => {
      this.$store.commit(
        'radios',
        result.data.filter(x => x.isMana == readIsManaVersionFlag())
      );
    });
    axios.get(`${fullStaticUrl}assetsConfig.json?` + Date.now()).then(result => {
      this.buildNumber = result.data.buildNumber;
    });
  },
  methods: {
    startLoading() {
      return (this.loadingShowcase = true);
    },
    activateTab(index) {
      this.activeTab = index;
      this.startLoading();
    },
    onLoadedAction() {
      this.showcaseLoaded();
    },
    showcaseLoaded() {
      this.loadingShowcase = false;
      if (this.$refs.showcase) {
        const selectionBoxes = this.$refs.showcase.$el.querySelectorAll(
          '.SelectionBox'
        );

        selectionBoxes.forEach(s => {
          const id = s.parentNode?.dataset?.name || s.parentNode?.id;
          s.onclick = e => this.clickedSelectionBox(e, id);
        });
      }
    },
    clickedSelectionBox(e, s) {
      e.preventDefault();
      const product = this.findProduct(s);
      this.$router.push({
        name: `${product.prefix}${product.name}`,
        query: { from: 'showcase', activeTab: this.activeTab }
      });
    },
    findProduct(id) {
      const product = { prefix: '', name: '' };
      this.$store.state.radios.forEach(section => {
        const radio = section.radios.find(radio => {
          return radio.id === id
        });
        if (radio) {
          product.prefix = section.prefix;
          product.name = radio.name;
        }
      });
      return product;
    },
    goBack() {
      this.$router.push({ name: 'radio' });
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.main {
  display: flex;
  flex: 1;
  background-color: @layer1;
  .content {
    margin: @space-base @space-large @space-large @space-large;
    display: flex;
    flex: 1;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: row;
    }
  }
}

.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  .header {
    display: flex;
    justify-content: space-between;
    h2 {
      margin: @space-large @space-xl;
    }
    .labels {
      margin: @space-base @space-large;
      span {
        margin: 0 @space-small;
        font-size: @label-font-size;
        padding: 0 0 2px 0;
      }
      .capacity {
        border-bottom: 2px solid @orange-50;
      }
      .compact {
        border-bottom: 2px solid @green-35;
      }
      .coverage {
        border-bottom: 2px solid @blue-43;
      }
    }
  }
  .body {
    display: flex;
    flex: 1;
  }
}

.placeholder {
  position: relative;
  display: block;
  height: 100%;
}

.image-container {
  width: 100%;
  height: 100%;
}
svg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  ::v-deep .SelectionBox {
    cursor: pointer;
    color: #00000000;
    /*   &:hover {
      + line {
        stroke-width: 5px;
      }
    }
    + line {
      stroke-width: 0px;
    } */
    fill: transparent;
  }
}
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bottom-escape {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: @space-xxl;
  padding-right: @space-xl;
  padding-bottom: @space-large;
  .icon-general {
    width: @font-size-lg;
    height: @font-size-lg;
  }
}
</style>
